/**
 * Reports Service Schemas
 *
 * Zod validation schemas for report service commands.
 */

import { z } from 'zod/v4'

export const DefineReportInputSchema = z.object({
  yaml: z.string().describe('YAML template content'),
})

export const GenerateReportInputSchema = z.object({
  template: z.string().optional().describe('Template handle'),
  templateYaml: z.string().optional().describe('Inline YAML template'),
  arguments: z
    .record(z.string(), z.unknown())
    .default({})
    .describe('Report arguments'),
  format: z.enum(['static', 'interactive', 'auto']).optional().default('auto'),
})

export type DefineReportInput = z.infer<typeof DefineReportInputSchema>
export type GenerateReportInput = z.infer<typeof GenerateReportInputSchema>
